import baseLoadable from '@loadable/component';
import React from 'react';
import Spinner from '../../components/utils/Spinner';
export default function loadable(func, options) {
    const { fullScreen = true, ...rest } = options || {};
    return baseLoadable(func, {
        fallback: <Spinner fullScreen={fullScreen} {...rest}/>,
    });
}
